import { defineMessages, useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';

import { Hotkey } from 'ui-components/components/hotkey';
import { ChildrenPropType } from '../../prop-types/children';

export const messages = defineMessages({
  name: {
    description: 'modalHotkey.next',
    defaultMessage: 'Move to the next window',
    id: 'CGi8Zc',
  },
});

export const hotkey = ['ArrowRight'];
export const barcodeContent = '+T9Y3ZY53NGAT=';

export const GoToNextModalHotkey = ({ children = null, onNavigate }) => {
  const intl = useIntl();
  const hotkeyMetadata = useMemo(
    () => ({
      displayHotkeyStrings: hotkey,
      hotkey,
      barcode: barcodeContent,
      handler: onNavigate,
      name: intl.formatMessage(messages.name),
      legacyCategory: 'general',
      doNotTrack: true,
    }),
    [intl, onNavigate],
  );

  return (
    <>
      <Hotkey hotkey={hotkeyMetadata} />
      {children}
    </>
  );
};

GoToNextModalHotkey.propTypes = {
  children: ChildrenPropType,
  onNavigate: PropTypes.func.isRequired,
};
